import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box } from '@chakra-ui/react';
import { useState } from 'react';
import { Dismiss, Location } from '../../assets/icons';
import Autocomplete from '../Autocomplete';
import Icon from '../Icon';
import { jsx as _jsx } from "react/jsx-runtime";
export default function AutocompleteLocation(_ref) {
  var items = _ref.items,
    inputSelectedValue = _ref.inputSelectedValue,
    hasClearIcon = _ref.hasClearIcon,
    hasListDivider = _ref.hasListDivider,
    openListOnFocus = _ref.openListOnFocus,
    disableInternalFilter = _ref.disableInternalFilter,
    isRequired = _ref.isRequired,
    onChange = _ref.onChange,
    onSelectOption = _ref.onSelectOption,
    onInputChange = _ref.onInputChange,
    onClearInput = _ref.onClearInput,
    onBlurInput = _ref.onBlurInput,
    onFocusInput = _ref.onFocusInput,
    autocompleteStyles = _ref.autocompleteStyles,
    inputPlaceholder = _ref.inputPlaceholder,
    dataTestId = _ref.dataTestId,
    _ref$showElements = _ref.showElements,
    showElements = _ref$showElements === void 0 ? false : _ref$showElements,
    hasItemObject = _ref.hasItemObject,
    isPriceFinder = _ref.isPriceFinder,
    ariaInvalid = _ref.ariaInvalid,
    ariaDescribedBy = _ref.ariaDescribedBy;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    inputHasFocus = _useState2[0],
    setInputHasFocus = _useState2[1];
  var _getAutocompleteLocat = getAutocompleteLocationStyles(autocompleteStyles),
    inputStyles = _getAutocompleteLocat.inputStyles,
    wrapperStyles = _getAutocompleteLocat.wrapperStyles,
    listStyles = _getAutocompleteLocat.listStyles;
  var autoCompleteProps = {
    items,
    onChange,
    onSelectOption,
    onInputChange,
    onBlurInput,
    onFocusInput,
    setInputHasFocus,
    inputPlaceholder,
    openListOnFocus,
    disableInternalFilter,
    isRequired,
    hasListDivider,
    icons: {
      left: showElements ? () => _jsx(Location, {
        color: "var(--chakra-colors-darkGrey1)"
      }) : null,
      right: props => inputHasFocus ? _jsx(ClearInputIcon, _objectSpread({}, props)) : null
    },
    inputStyles,
    wrapperStyles,
    listStyles,
    autocompleteStyles,
    inputSelectedValue,
    dataTestId,
    showElements,
    hasItemObject,
    isPriceFinder,
    ariaInvalid,
    ariaDescribedBy
  };
  return _jsx(Autocomplete, _objectSpread({}, autoCompleteProps));
  function ClearInputIcon(_ref2) {
    var autocompleteRef = _ref2.autocompleteRef,
      autocompleteInputRef = _ref2.autocompleteInputRef;
    return _jsx(Box, {
      bg: hasClearIcon && inputHasFocus ? 'lightGrey2' : 'inherit',
      borderRadius: "50%",
      p: "xs",
      cursor: "pointer",
      "aria-label": "clear-icon",
      "data-testid": "".concat(dataTestId, "-clearLocationButton"),
      onMouseDown: event => {
        var _autocompleteRef$curr, _autocompleteRef$curr2, _autocompleteRef$curr3, _autocompleteRef$curr4, _autocompleteInputRef, _autocompleteInputRef2;
        event.preventDefault();
        autocompleteRef === null || autocompleteRef === void 0 || (_autocompleteRef$curr = autocompleteRef.current) === null || _autocompleteRef$curr === void 0 || (_autocompleteRef$curr2 = _autocompleteRef$curr.resetItems) === null || _autocompleteRef$curr2 === void 0 || _autocompleteRef$curr2.call(_autocompleteRef$curr);
        autocompleteRef === null || autocompleteRef === void 0 || (_autocompleteRef$curr3 = autocompleteRef.current) === null || _autocompleteRef$curr3 === void 0 || (_autocompleteRef$curr4 = _autocompleteRef$curr3.removeItem) === null || _autocompleteRef$curr4 === void 0 || _autocompleteRef$curr4.call(_autocompleteRef$curr3, autocompleteInputRef === null || autocompleteInputRef === void 0 || (_autocompleteInputRef = autocompleteInputRef.current) === null || _autocompleteInputRef === void 0 ? void 0 : _autocompleteInputRef.value);
        (_autocompleteInputRef2 = autocompleteInputRef.current) === null || _autocompleteInputRef2 === void 0 || _autocompleteInputRef2.focus();
        onClearInput && onClearInput();
      },
      children: _jsx(Box, {
        as: "span",
        display: "".concat(hasClearIcon && inputHasFocus ? 'initial' : 'none'),
        children: _jsx(Icon, {
          style: {
            transform: 'scale(0.7)'
          },
          svg: _jsx(Dismiss, {})
        })
      })
    }, "clear-input-icon");
  }
}
var getAutocompleteLocationStyles = autocompleteStyles => {
  var inputStyles = _objectSpread(_objectSpread({
    variant: 'unstyled',
    textOverflow: 'ellipsis',
    py: 'md',
    border: '1px solid transparent',
    cursor: 'pointer',
    _hover: {
      border: '1px solid var(--chakra-colors-darkGrey1)',
      borderRadius: '4px'
    },
    _focus: {
      border: '2px solid var(--chakra-colors-primary)',
      cursor: 'auto',
      borderRadius: '4px'
    },
    _placeholder: {
      color: 'var(--chakra-colors-darkGrey2)',
      fontStyle: 'normal'
    },
    borderRadius: '4px'
  }, autocompleteStyles === null || autocompleteStyles === void 0 ? void 0 : autocompleteStyles.inputElementStyles), autocompleteStyles === null || autocompleteStyles === void 0 ? void 0 : autocompleteStyles.errorInputElementStyles);
  var wrapperStyles = _objectSpread(_objectSpread(_objectSpread({
    w: '50%'
  }, autocompleteStyles === null || autocompleteStyles === void 0 ? void 0 : autocompleteStyles.inputGroupStyles), autocompleteStyles === null || autocompleteStyles === void 0 ? void 0 : autocompleteStyles.errorInputGroupStyles), autocompleteStyles === null || autocompleteStyles === void 0 ? void 0 : autocompleteStyles.locationErrorGroupStyles);
  var listStyles = _objectSpread({}, autocompleteStyles.listStyles);
  return {
    inputStyles,
    wrapperStyles,
    listStyles
  };
};